import { Marks } from '@ametista-ai/editor/constants';
import { useEditorEventCallback } from '@handlewithcare/react-prosemirror';
import { toggleMark } from 'prosemirror-commands';

export function useToggleEditorMark(mark: Marks) {
  return useEditorEventCallback((view) => {
    if (!view) {
      return;
    }

    toggleMark(view.state.schema.marks[mark])(view.state, view.dispatch, view);
    view.focus();
  });
}
